import script from "./BlogCategoryEdit.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlogCategoryEdit.vue?vue&type=script&lang=ts&setup=true"

import "./BlogCategoryEdit.vue?vue&type=style&index=0&id=751bd40a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-751bd40a"]])

export default __exports__